// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'erase-solid';

export const Component = () => (
  <path d='m24.09 7.322-5.89-5.89A1.408 1.408 0 0 0 17.146 1c-.431 0-.766.144-1.054.431L.432 17.092A1.408 1.408 0 0 0 0 18.146c0 .431.144.767.431 1.054l4.359 4.359h16.283c.336 0 .527-.144.527-.48 0-.334-.191-.526-.527-.526H10.92l13.17-13.17c.288-.24.432-.575.432-1.006 0-.43-.144-.766-.431-1.054v-.001Zm-7.71 8.381-6.848 6.849H5.413c-.047.047-.143.047-.191.047L1.103 18.48c-.096-.19-.144-.287-.144-.335 0-.047.048-.143.144-.335L9.82 9.141l6.56 6.561v.001Z' />
);

export const viewBox = '0 0 25 25';
